import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const base = 'https://assets.bizwise.com';

const sectionsBase = `${base}/landing-ui/sections`;
const sectionsWidth = 1000;

const locationsBase = `${base}/landing-ui/locations`;
const locationsWidth = 250;

const authBase = `${base}/landing-ui/auth-images`;
const authWidth = 1000;

const productsBase = `${base}/landing-ui/product-images`;
const productsWidth = 1000;

export const SectionImages: React.ReactElement[] = [
  <StaticImage width={sectionsWidth} alt="Male leatherworker making belt" src={`${sectionsBase}/1.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Makeup artist" src={`${sectionsBase}/2.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Coffee shop baristas meeting" src={`${sectionsBase}/3.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Female painter" src={`${sectionsBase}/4.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Three people at business meeting" src={`${sectionsBase}/5.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Boat captain" src={`${sectionsBase}/6.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Coffee shop barista making an espresso" src={`${sectionsBase}/7.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Business woman packaging mugs" src={`${sectionsBase}/8.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Programmer woman" src={`${sectionsBase}/9.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Woman taking notes" src={`${sectionsBase}/10.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Business woman packaging mugs" src={`${sectionsBase}/11.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Hairstylist blow drying hair" src={`${sectionsBase}/12.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Male carpenter" src={`${sectionsBase}/13.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Hairstylist cutting hair" src={`${sectionsBase}/14.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Woman writing signature on phone" src={`${sectionsBase}/15.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Man speaking into microphone" src={`${sectionsBase}/16.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Man speaking into microphone" src={`${sectionsBase}/17.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Two women with tablets" src={`${sectionsBase}/18.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Man typing on laptop" src={`${sectionsBase}/19.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Women staring at phone" src={`${sectionsBase}/20.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Two women sharing a laptop" src={`${sectionsBase}/21.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Four people sharing a laptop" src={`${sectionsBase}/22.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Man smiling on phone with laptop" src={`${sectionsBase}/23.png`} />,
  <StaticImage width={sectionsWidth} alt="Woman looking at a monitor" src={`${sectionsBase}/24.png`} />,
  <StaticImage width={sectionsWidth} alt="Man working on a laptop" src={`${sectionsBase}/25.png`} />,
  <StaticImage width={sectionsWidth} alt="Four people holding hands together" src={`${sectionsBase}/30.jpg`} />,
  <StaticImage width={sectionsWidth} alt="Four people in a meeting" src={`${sectionsBase}/31.jpg`} />,
];

export const LocationImages: React.ReactElement[] = [
  <StaticImage width={locationsWidth} alt="Bizwise office San Francisco" src={`${locationsBase}/1.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Austin" src={`${locationsBase}/2.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Boulder" src={`${locationsBase}/3.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Denver" src={`${locationsBase}/4.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Los Angeles" src={`${locationsBase}/5.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office New York City" src={`${locationsBase}/6.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Phoenix" src={`${locationsBase}/7.jpg`} />,
  <StaticImage width={locationsWidth} alt="Bizwise office Seattle" src={`${locationsBase}/8.jpg`} />,
];

export const AuthImages: React.ReactElement[] = [
  <StaticImage width={authWidth} alt="Man inspecting coffee beans" src={`${authBase}/1.jpg`} />,
  <StaticImage width={authWidth} alt="Barber cutting hair" src={`${authBase}/2.jpg`} />,
  <StaticImage width={authWidth} alt="Cleaner sanitizing windows" src={`${authBase}/3.jpg`} />,
  <StaticImage width={authWidth} alt="Man working on laptop" src={`${authBase}/4.jpg`} />,
  <StaticImage width={authWidth} alt="Pastry chef making pastries" src={`${authBase}/5.jpg`} />,
  <StaticImage width={authWidth} alt="People waiting at coffee bar" src={`${authBase}/6.jpg`} />,
  <StaticImage width={authWidth} alt="Hairstylist blow drying hair" src={`${authBase}/7.jpg`} />,
];

export const EmailImages: React.ReactElement[] = [
  <StaticImage width={productsWidth} alt="Email module screenshot" src={`${productsBase}/Email1.png`} />,
  <StaticImage width={productsWidth} alt="Email module screenshot" src={`${productsBase}/Email2.png`} />,
  <StaticImage width={productsWidth} alt="Email module screenshot" src={`${productsBase}/Email3.png`} />,
  <StaticImage width={productsWidth} alt="Email module screenshot" src={`${productsBase}/Email4.png`} />,
  <StaticImage width={productsWidth} alt="Email module screenshot" src={`${productsBase}/Email5.png`} />,
];
